declare var ga: any;

export class GA {

    public static sendCurrentPageView() {
        this.sendPageView(window.location.pathname, document.title);
    }

    public static sendPageView(page: string, title?: string) {
        var p: any = {};
        p.hitType = 'pageview';
        p.page = page;
        if (title != null) {
            p.title = title;
        }
        ga('send', p);
    }

    public static sendEvent(category: string, action: string, label?: string, value?: number) {
        var p: any = {};
        p.hitType = 'event';
        p.eventCategory = category;
        p.eventAction = action;
        if (label != null) {
            p.eventLabel = label;
        }
        if (value != null) {
            p.eventValue = value;
        }
        ga('send', p);
    }

    private constructor() {}

}